import { type PropsWithChildren } from 'react';

import { AnnotationsTrackProps } from '../../core/components/annotations/types/annotations-track-props.js';

export const Track = (props: PropsWithChildren<AnnotationsTrackProps>) => null;

Track['displayName'] = 'Annotations.Track';
